export class FileSearch {

    PatientId: string;

    MobileNumber: string;
    CPRNO: string;
    NationalId: string;
    PatientName: string;
    FIRST_NAME: string;
    MIDDLE_NAME: string;
    LAST_NAME: string;
    EMAIL: string;
    ISCashPatient: boolean;
    IsInsuranceFlag: boolean;
    FollowVistCount: number;
    Sex: string;
    Age: string;
    PediatricAge: string;
    PediatricDept: string;
    OBGYDept: string;
    IsPediatricAge: boolean;
    IsOBGYN: boolean;
    DummyMobileNumber: string;
    REGISTERCOUNT: string;
    REGISTERNO: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/searchdashboard/filesearch.ts